import { HttpMethod, RequestOptions, useUserRequest } from "../common/lib/fetch";

const useUnregisterKiosk = (siteId: string, kioskId: string, options: RequestOptions) =>
  useUserRequest({
    path: `/api/sites/${siteId}/kiosks/${kioskId}/unregister`,
    method: HttpMethod.POST
  }, options);

export default useUnregisterKiosk;